// create form
// API related actions
export const FETCHING_ONLY_FORM_ANSWERS = '@@toyota/FETCHING_ONLY_FORM_ANSWERS';
export const FETCHED_ONLY_FORM_ANSWERS = '@@toyota/FETCHED_ONLY_FORM_ANSWERS';
export const FETCHED_ONLY_FORM_ANSWERS_FAILED = '@@toyota/FETCHED_ONLY_FORM_ANSWERS_FAILED';
export const FETCHING_FORM_TEMPLATE = '@@toyota/FETCHING_FORM_TEMPLATE';
export const FETCHED_FORM_TEMPLATE = '@@toyota/FETCHED_FORM_TEMPLATE';
export const FETCHED_FORM_TEMPLATE_FAILED = '@@toyota/FETCHED_FORM_TEMPLATE_FAILED';
export const SAVING_FORM = '@@toyota/SAVING_FORM';
export const SAVED_FORM = '@@toyota/SAVED_FORM';
export const SAVED_FORM_FAILED = '@@toyota/SAVED_FORM_FAILED';
export const FETCHING_CHASSIS_INFO = '@@toyota/FETCHING_CHASSIS_INFO';
export const FETCHED_CHASSIS_INFO = '@@toyota/FETCHED_CHASSIS_INFO';
export const FETCHED_CHASSIS_INFO_FAILED = '@@toyota/FETCHED_CHASSIS_INFO_FAILED';
export const FETCHING_FORM_RESPONSE = '@@toyota/FETCHING_FORM_RESPONSE';
export const FETCHED_FORM_RESPONSE = '@@toyota/FETCHED_FORM_RESPONSE';
export const FETCHED_FORM_RESPONSE_FAILED = '@@toyota/FETCHED_FORM_RESPONSE_FAILED';
export const DELETING_FORM = '@@toyota/DELETING_FORM';
export const DELETED_FORM = '@@toyota/DELETED_FORM';
export const DELETED_FORM_FAILED = '@@toyota/DELETED_FORM_FAILED';

// complementary actions
export const CLEAR_FORM = '@@toyota/CLEAR_FORM';
export const SET_GENERAL_INFO = '@@toyota/SET_GENERAL_INFO';
export const SET_VALUE_IN_FORM = '@@toyota/SET_VALUE_IN_FORM';
export const SET_FILES = '@@toyota/SET_FILES';
export const CHANGE_SAVED_VALUE = '@@toyota/CHANGE_SAVED_VALUE';
export const DO_NOT_SHOW_MESSAGE = '@@toyota/DO_NOT_SHOW_MESSAGE';

// list form
// API related actions
export const FETCHING_FORMS_LIST = '@@toyota/FETCHING_FORMS_LIST';
export const FETCHED_FORMS_LIST = '@@toyota/FETCHED_FORMS_LIST';
export const FETCHED_FORMS_LIST_FAILED = '@@toyota/FETCHED_FORMS_LIST_FAILED';

// complementary actions
export const CLEAR_FORMS_LIST = '@@toyota/CLEAR_FORMS_LIST';

// search
// API related actions
export const FETCHING_PUBLISHED_ANSWERS_LIST = '@@toyota/FETCHING_PUBLISHED_ANSWERS_LIST';
export const FETCHED_PUBLISHED_ANSWERS_LIST = '@@toyota/FETCHED_PUBLISHED_ANSWERS_LIST';
export const FETCHED_PUBLISHED_ANSWERS_LIST_FAILED = '@@toyota/FETCHED_PUBLISHED_ANSWERS_LIST_FAILED';

// complementary actions
export const CHANGE_SEARCH_FTR_LIST_PAGE = '@@toyota/CHANGE_SEARCH_FTR_LIST_PAGE';
export const CHANGE_SEARCH_FTR_LIST_PAGE_SIZE = '@@toyota/CHANGE_SEARCH_FTR_LIST_PAGE_SIZE';

// entered FTR
// API related actions
export const FETCHING_ENTERED_ANSWERS_LIST = '@@toyota/FETCHING_ENTERED_ANSWERS_LIST';
export const FETCHED_ENTERED_ANSWERS_LIST = '@@toyota/FETCHED_ENTERED_ANSWERS_LIST';
export const FETCHED_ENTERED_ANSWERS_LIST_FAILED = '@@toyota/FETCHED_ENTERED_ANSWERS_LIST_FAILED';

// Record API
export const FETCHING_RECORD_MESSAGES_LIST = '@@toyota/FETCHING_RECORD_MESSAGES_LIST';
export const FETCHED_RECORD_MESSAGES_LIST = '@@toyota/FETCHED_RECORD_MESSAGES_LIST';
export const FETCHED_RECORD_MESSAGES_LIST_FAILED = '@@toyota/FETCHED_RECORD_MESSAGES_LIST_FAILED';

export const ADDING_RECORD_MESSAGES_LIST = '@@toyota/ADDING_RECORD_MESSAGES_LIST';
export const ADDED_RECORD_MESSAGES_LIST = '@@toyota/ADDED_RECORD_MESSAGES_LIST';
export const ADDED_RECORD_MESSAGES_LIST_FAILED = '@@toyota/ADDED_RECORD_MESSAGES_LIST_FAILED';


// UPDATE STATE FORM
export const UPDATING_STATE_FORM = '@@toyota/UPDATING_STATE_FORM';
export const UPDATED_STATE_FORM = '@@toyota/UPDATED_STATE_FORM';
export const UPDATED_STATE_FORM_FAILED = '@@toyota/UPDATED_STATE_FORM_FAILED';

export const CLEAR_PUBLISHED_ANSWERS_LIST = '@@toyota/CLEAR_PUBLISHED_ANSWERS_LIST';

